import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import '@/i18n'; // i18n must be imported before App
import App from "./app";
import { ErrorBoundary } from '@/components/ErrorBoundary';
import './styles/global.css';
import { initAnalytics } from '@/lib/analytics';

// Inicializa analytics antes do render
initAnalytics();

/**
 * Main Entry Point
 * React 19 root rendering with i18n Suspense + Error Boundary
 */
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <Suspense fallback={<div style={{ position: 'fixed', inset: 0, background: '#000' }} />}>
        <App />
      </Suspense>
    </ErrorBoundary>
  </StrictMode>
);
